<template>
  <div class="services___content">
    <i-liner-heading tag="h2">{{ __("Select a topic") }}</i-liner-heading>
    <div class="services">
      <div
        v-for="service in services"
        :key="service.GroupID"
        @click="$emit('groupSelected', service.GroupID)"
        :to="{
          name: 'OpenServiceCall',
          params: {
            service: service.GroupID,
          },
        }"
        class="service"
      >
        <i-icon :name="service.icomName" />
        <span>{{ __(service.GroupName) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    services: Array,
  },
  emits: ["groupSelected"],
};
</script>

<style scoped>
.services {
  display: grid;
  gap: 20px 35px;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, 75px);

  padding-bottom: 20px;
  height: 76vh;
  overflow: scroll;
}

.service {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  line-height: 1.13;
  text-decoration: none;
}

.service span {
  margin-top: 8px;
  text-align: center;

  color: black;
  font-size: 16px;
}

.services:deep(.svg) {
  color: var(--color-primary);
}
</style>
